<template>
  <BlBackdrop
    label="Update"
    :submitLoading="submitLoading"
    :disabled="isDisabledSubmit"
    @backdrop-close="$emit('close-modal')"
    @backdrop-action="onSubmit"
  >
    <div class="flex flex-col gap-4 px-8 pt-8" :style="{ width: '40rem' }">
      <div class="flex flex-col gap-2">
        <div class="flex items-center gap-2">
          <div class="p-1 bg-orange-300" :style="{ borderRadius: '4px' }">
            <BlIcon icon="tooltip" class="h-6 w-6" />
          </div>
          <BlTextTitle4 text="Edit action recommendations" />
        </div>
        <BlTextBody2
          text="Get recommendation after the session when client passes certain conditions."
        />
      </div>
      <ActionRecommendationInput
        :navigateSuccessMetric="false"
        :totalSuccess="totalSuccessInput"
        :consecutiveSuccess="consecutiveSuccessInput"
        @input="onInputActionRecommendation($event)"
      />
    </div>
  </BlBackdrop>
</template>

<script>
import { mapActions } from "vuex";
import ActionRecommendationInput from "./ActionRecommendationInput.vue";

import BlBackdrop from "../../../BlBackdrop.vue";
import BlIcon from "../../../BlIcon.vue";
import BlTextBody2 from "../../../BlTextBody2.vue";
import BlTextTitle4 from "../../../BlTextTitle4.vue";

export default {
  name: "EditActionRecommendationsModal",
  components: {
    BlBackdrop,
    ActionRecommendationInput,
    //
    BlIcon,
    BlTextTitle4,
    BlTextBody2
  },
  props: ["actionRecommendation"],
  data() {
    return {
      submitLoading: false,
      totalSuccessChecked: false,
      totalSuccessInput: null,
      consecutiveSuccessChecked: false,
      consecutiveSuccessInput: null
    };
  },
  watch: {
    actionRecommendation(val) {
      this.setupDefault(val);
    }
  },
  computed: {
    isDisabledSubmit() {
      if (this.totalSuccessChecked) {
        if (this.totalSuccessInput === "" || this.totalSuccessInput === null) {
          return true;
        }
      }
      if (this.consecutiveSuccessChecked) {
        if (
          this.consecutiveSuccessInput === "" ||
          this.consecutiveSuccessInput === null
        ) {
          return true;
        }
      }
      return false;
    }
  },
  mounted() {
    this.setupDefault(this.actionRecommendation);
  },
  methods: {
    ...mapActions([
      "createActionRecommendation",
      "updateActionRecommendation",
      "showToast"
    ]),
    setupDefault(val) {
      if (val.total_success !== null) {
        this.totalSuccessChecked = true;
        this.totalSuccessInput = val.total_success;
      }
      if (val.consecutive_success !== null) {
        this.consecutiveSuccessChecked = true;
        this.consecutiveSuccessInput = val.consecutive_success;
      }
    },
    onInputActionRecommendation(val) {
      this.totalSuccessChecked = val.total_success_checked;
      this.totalSuccessInput = val.total_success;
      this.consecutiveSuccessChecked = val.consecutive_success_checked;
      this.consecutiveSuccessInput = val.consecutive_success;
    },
    async onSubmit() {
      if (this.totalSuccessChecked && this.totalSuccessInput < 1) {
        const title = "Invalid input";
        const message =
          "Please enter a value greater than or equal to 1 for total success.";
        this.showToast({ title, message, type: "error" });
        return;
      }
      if (this.consecutiveSuccessChecked && this.consecutiveSuccessInput < 2) {
        const title = "Invalid input";
        const message =
          "Please enter a value greater than or equal to 2 for consecutive.";
        this.showToast({ title, message, type: "error" });
        return;
      }

      const params = {
        kind: "client",
        target_id: this.actionRecommendation.target_id,
        id: this.actionRecommendation.id,
        action_recommendation: {
          target_id: this.actionRecommendation.target_id,
          total_success: this.totalSuccessChecked
            ? this.totalSuccessInput
            : null,
          consecutive_success: this.consecutiveSuccessChecked
            ? this.consecutiveSuccessInput
            : null,
          recommended_action: "mastered"
        }
      };

      this.submitLoading = true;
      if (!this.actionRecommendation.id) {
        const { success } = await this.createActionRecommendation(params);
        this.submitLoading = false;
        if (!success) return;
      } else {
        const { success } = await this.updateActionRecommendation(params);
        this.submitLoading = false;
        if (!success) return;
      }

      const title = "Action recommendations updated";
      const message = "Success! The action recommendations have been updated.";
      this.showToast({ title, message, type: "success" });
      this.$emit("close-modal");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/clients/target/modal/EditActionRecommendationsModal.vue